import { NavigationMenuItem, NavigationMenuItemWithSubItems } from '../types/NavigationMenuItem'
import { TransformItemsStructure } from './transformItemsStructure'

export const hasSubItems = (
  item: NavigationMenuItem | TransformItemsStructure,
): item is NavigationMenuItemWithSubItems => {
  return 'subItems' in item && Array.isArray(item.subItems) && item.subItems.length > 0
}
